import {
  Box,
  Divider,
  Grid,
  InputLabel,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { connectWithSocketServer } from "../../realTimeCommunication/SocketConnection";
import { unlockNotificationAudioSilently } from "../../realTimeCommunication/notificationSound";
import {
  clearErrors,
  getCurrentUser,
  Login,
  forgotPassword,
} from "../../Redux/Actions/Auth";
import { getAllNotifications } from "../../Redux/Actions/Employee";
import { errorNotify, successNotify } from "../../Utils/toast";
import { useStyle } from "./login-style";
import { IoEyeOff, IoEye } from "react-icons/io5";
import "./UserLogin.css";
import ReactModal from "../../Components/Modal/Modal";
import { getUser, validateEmail } from "../../Utils/helper";
import { getAllFilteredEmployees } from "../../Redux/Actions/HR";
const UserLogin = () => {
  const classes = useStyle();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const audio = new Audio("/iphone_sound.mp3");
  const { loading, user, error } = useSelector((state) => state.Auth);
  const forgotState = useSelector((state) => state.forgotPassword || {});

  let userAuth = getUser() ? getUser() || "" : null;
  useEffect(() => {
    if (userAuth) {
      if (userAuth?.employee?.role === "admin") {
        navigate(`HR/dashboard`);
      } else if (userAuth?.employee?.role) {
        navigate(`${userAuth?.employee.role}/dashboard`);
      } else {
        navigate("/");
      }
    }
  }, [userAuth]);
  useEffect(() => {
    if (user?.success) {
      successNotify(user?.message);
      connectWithSocketServer(userAuth, audio);
      dispatch(getCurrentUser());
      dispatch(getAllNotifications());
      dispatch(getAllFilteredEmployees());
      dispatch({ type: "LOGIN_RESET" });
    }
    if (error) {
      errorNotify(error);
      dispatch(clearErrors());
    }
  }, [dispatch, user, error]);

  useEffect(() => {
    if (forgotState?.response?.message) {
      successNotify(forgotState.response.message);
      setForgotOpen(false);
      setForgotEmail("");
      dispatch({ type: "FORGOT_PASSWORD_RESET" });
    }
    if (forgotState?.error) {
      errorNotify(forgotState.error);
      dispatch(clearErrors());
    }
  }, [forgotState, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email === "" || password === "") {
      errorNotify("Please fill in all fields");
    } else if (password.length < 8) {
      errorNotify("Invalid email or password");
    } else if (!validateEmail(email)) {
      errorNotify("Invalid email or password");
    } else {
      unlockNotificationAudioSilently(audio);
      dispatch(Login({ email, password }));
    }
  };

  const handleForgotSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(forgotEmail)) {
      errorNotify("Please enter a valid email");
      return;
    }
    dispatch(forgotPassword(forgotEmail.trim()));
  };
  return (
    <Box className={classes.loginContainer}>
      <Grid
        item
        container
        sx={{ height: "100%", width: "100%" }}
        direction="row"
        justifyContent="flex-end"
        alignItems={"center"}
      >
        <Grid xs={7} item sx={{ mr: 3 }}>
          <Paper className={classes.loginCard}>
            <Box sx={{ width: "80%" }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: "900", fontSize: "28px", color: "#010101" }}
              >
                <span style={{ color: "#00ACF7" }}>LOGIN</span> ACCOUNT
              </Typography>
              <form onSubmit={handleSubmit}>
                <Box sx={{ my: 2 }}>
                  <InputLabel sx={{ fontWeight: "700" }}>Email</InputLabel>
                  <TextField
                    placeholder="Enter email"
                    fullWidth
                    className={classes.inputContainer}
                    value={email}
                    onChange={(e) => setEmail(e.target.value.trim())}
                  />
                </Box>
                <Box sx={{ my: 2 }}>
                  <InputLabel sx={{ fontWeight: "700" }}>Password</InputLabel>
                  <div className="password__field__wrapper">
                    <TextField
                      placeholder="password"
                      type={passwordShow ? "" : "password"}
                      fullWidth
                      className={classes.inputContainer}
                      value={password}
                      onChange={(e) => setPassword(e.target.value.trim())}
                    />
                    <button
                      type="button"
                      className="password__toggle_btn"
                      aria-label={
                        passwordShow ? "Hide password" : "Show password"
                      }
                      onClick={() => setPasswordShow(!passwordShow)}
                    >
                      {passwordShow ? (
                        <IoEye size={22} />
                      ) : (
                        <IoEyeOff size={22} />
                      )}
                    </button>
                  </div>
                  <div style={{ textAlign: "right", marginTop: 6 }}>
                    <button
                      type="button"
                      onClick={() => setForgotOpen(true)}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#0097D9",
                        cursor: "pointer",
                        fontWeight: 600,
                      }}
                    >
                      Forgot password?
                    </button>
                  </div>
                </Box>
                <Divider />
                <button
                  className="login_btn"
                  type="submit"
                  disabled={!!loading}
                >
                  {!loading ? (
                    "Login"
                  ) : (
                    <Spinner size="sm" animation="border" />
                  )}
                </button>
              </form>
              <ReactModal
                open={forgotOpen}
                setOpen={setForgotOpen}
                title="Forgot Password"
                size={500}
              >
                <form onSubmit={handleForgotSubmit}>
                  <Box sx={{ my: 1 }}>
                    <InputLabel sx={{ fontWeight: 700 }}>Email</InputLabel>
                    <TextField
                      placeholder="Enter your email"
                      fullWidth
                      value={forgotEmail}
                      onChange={(e) => setForgotEmail(e.target.value)}
                    />
                  </Box>
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}
                  >
                    <button
                      className="login_btn"
                      type="submit"
                      disabled={!!forgotState?.loading}
                      style={{ width: 180 }}
                    >
                      {!forgotState?.loading ? (
                        "Send Email"
                      ) : (
                        <Spinner size="sm" animation="border" />
                      )}
                    </button>
                  </Box>
                </form>
              </ReactModal>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserLogin;
